var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWallpaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36444 9.71666C5.89489 9.71666 4.69548 8.43215 4.69548 6.85833C4.69548 5.29609 5.89489 4 7.36444 4C8.82318 4 10.0226 5.29609 10.0226 6.85833C10.0226 8.43215 8.82318 9.71666 7.36444 9.71666ZM2.67485 20C1.62672 20 1 19.3288 1 18.1947V17.009C1 16.1808 1.344 15.3894 1.95052 14.8224L4.31729 12.6097C4.79273 12.1584 5.31139 11.927 5.78684 11.927C6.31631 11.927 6.86739 12.1584 7.34283 12.6329L9.40668 14.6233L14.5717 9.71666C15.1012 9.20749 15.6955 8.97604 16.3114 8.97604C16.9057 8.97604 17.5216 9.21906 18.0295 9.72823L22.7045 14.3649C22.8937 14.5525 23 14.8074 23 15.0732V18.2179C23 19.3288 22.3625 20 21.336 20H2.67485Z",
    fill: "#878793"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallpaper);
export default __webpack_public_path__ + "static/media/icon-wallpaper.e81038ea2545a0b5b8e2fcd89b336c72.svg";
export { ForwardRef as ReactComponent };